import React, { useState } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../../../components/index";
import { snackActions } from "../../../../utils/SnackBarUtils";
import { SuittService } from "../../../../services";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";


function UserEducationDocuments(
  {
    user = {},
    getUserInfo = () => {
    }
  }
) {
  const suittService = new SuittService();
  const [editUser, setEditUser] = useState(user);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const splittedName = name.split(".");
    if (splittedName.length > 1) {
      setEditUser({
        ...editUser,
        [splittedName[0]]: {
          ...editUser[splittedName[0]],
          [splittedName[1]]: value
        }
      });
    } else {
      setEditUser({ ...editUser, [name]: value });
    }
  };

  const updateUserInfo = async () => {
    const result = await suittService.updateUserInfo({ user: editUser });
    if (!result || !result?.status) return snackActions.error("Щось пішло не так");

    snackActions.success("Дані успішно оновлено");
    getUserInfo();
  };

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
    >
      <Grid container sx={{ padding: "10px 0" }}>
        <Grid sx={{ textAlign: "left" }} xs={12} sm={12} md={12}>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{display: 'flex', justifyContent: 'flex-end'}}>
            <Button onClick={updateUserInfo} variant={"contained"}>Оновити</Button>
          </Grid>
          <Grid container spacing={1} sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component={"b"} variant={"b"}>{"Документ про освіту (диплом):"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть серію та номер"}
                label={"Серія та номер"}
                variant="outlined"
                fullWidth
                value={editUser.educationDocument?.seriesNumber}
                type={"string"}
                name={"educationDocument.seriesNumber"}
                onChange={handleInputChange}
                helperText={"Вкажіть серію та номер"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть ким видано"}
                label={"Ким видано"}
                variant="outlined"
                fullWidth
                value={editUser.educationDocument?.issuedBy}
                type={"string"}
                name={"educationDocument.issuedBy"}
                onChange={handleInputChange}
                helperText={"Вкажіть ким видано"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <MobileDatePicker
                label={"Дата видачі"}
                inputFormat="MM/dd/yyyy"
                value={new Date(editUser.educationDocument?.dateOfIssue)}
                onChange={(newDate) => {
                  const newState = {
                    ...editUser
                  };
                  newState.educationDocument.dateOfIssue = newDate;
                  setEditUser(newState);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть спеціальність"}
                label={"Спеціальність"}
                variant="outlined"
                fullWidth
                value={editUser.educationDocument?.specialty}
                type={"string"}
                name={"educationDocument.specialty"}
                onChange={handleInputChange}
                helperText={"Вкажіть спеціальність"}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component={"b"} variant={"b"}>{"Диплом кандидата наук:"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть серію та номер"}
                label={"Серія та номер"}
                variant="outlined"
                fullWidth
                value={editUser.diplomaOfCandidateOfScience?.seriesNumber}
                type={"string"}
                name={"diplomaOfCandidateOfScience.seriesNumber"}
                onChange={handleInputChange}
                helperText={"Вкажіть серію та номер"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть ким видано"}
                label={"Ким видано"}
                variant="outlined"
                fullWidth
                value={editUser.diplomaOfCandidateOfScience?.issuedBy}
                type={"string"}
                name={"diplomaOfCandidateOfScience.issuedBy"}
                onChange={handleInputChange}
                helperText={"Вкажіть ким видано"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <MobileDatePicker
                label={"Дата видачі"}
                inputFormat="MM/dd/yyyy"
                value={new Date(editUser.diplomaOfCandidateOfScience?.dateOfIssue)}
                onChange={(newDate) => {
                  const newState = {
                    ...editUser
                  };
                  newState.diplomaOfCandidateOfScience.dateOfIssue = newDate;
                  setEditUser(newState);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть тему дисертації"}
                label={"Тема дисертації"}
                variant="outlined"
                fullWidth
                value={editUser.diplomaOfCandidateOfScience?.dissertationTopic}
                type={"string"}
                name={"diplomaOfCandidateOfScience.dissertationTopic"}
                onChange={handleInputChange}
                helperText={"Вкажіть тему дисертації"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть найменування спеціальності"}
                label={"Найменування спеціальності"}
                variant="outlined"
                fullWidth
                value={editUser.diplomaOfCandidateOfScience?.speciality}
                type={"string"}
                name={"diplomaOfCandidateOfScience.speciality"}
                onChange={handleInputChange}
                helperText={"Вкажіть найменування спеціальності"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть шифр спеціальності"}
                label={"Шифр спеціальності"}
                variant="outlined"
                fullWidth
                value={editUser.diplomaOfCandidateOfScience?.codeAndName}
                type={"string"}
                name={"diplomaOfCandidateOfScience.codeAndName"}
                onChange={handleInputChange}
                helperText={"Вкажіть шифр спеціальності"}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component={"b"} variant={"b"}>{"Диплом доктора філософії:"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть серію"}
                label={"Серія"}
                variant="outlined"
                fullWidth
                value={editUser.phD?.series}
                type={"string"}
                name={"phD.series"}
                onChange={handleInputChange}
                helperText={"Вкажіть серію"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть номер"}
                label={"Номер"}
                variant="outlined"
                fullWidth
                value={editUser.phD?.number}
                type={"string"}
                name={"phD.number"}
                onChange={handleInputChange}
                helperText={"Вкажіть номер"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть ким видано"}
                label={"Ким видано"}
                variant="outlined"
                fullWidth
                value={editUser.phD?.issuedBy}
                type={"string"}
                name={"phD.issuedBy"}
                onChange={handleInputChange}
                helperText={"Вкажіть ким видано"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <MobileDatePicker
                label={"Дата видачі"}
                inputFormat="MM/dd/yyyy"
                value={new Date(editUser.phD?.dateOfIssue)}
                onChange={(newDate) => {
                  const newState = {
                    ...editUser
                  };
                  newState.phD.dateOfIssue = newDate;
                  setEditUser(newState);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть тему дисертації"}
                label={"Тема дисертації"}
                variant="outlined"
                fullWidth
                value={editUser.phD?.dissertationTopic}
                type={"string"}
                name={"phD.dissertationTopic"}
                onChange={handleInputChange}
                helperText={"Вкажіть тему дисертації"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть найменування спеціальності"}
                label={"Найменування спеціальності"}
                variant="outlined"
                fullWidth
                value={editUser.phD?.speciality}
                type={"string"}
                name={"phD.speciality"}
                onChange={handleInputChange}
                helperText={"Вкажіть найменування спеціальності"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть шифр спеціальності"}
                label={"Шифр спеціальності"}
                variant="outlined"
                fullWidth
                value={editUser.phD?.codeAndName}
                type={"string"}
                name={"phD.codeAndName"}
                onChange={handleInputChange}
                helperText={"Вкажіть шифр спеціальності"}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component={"b"} variant={"b"}>{"Диплом доктора наук:"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть серію"}
                label={"Серія"}
                variant="outlined"
                fullWidth
                value={editUser.doctorOfScienceDiploma?.series}
                type={"string"}
                name={"doctorOfScienceDiploma.series"}
                onChange={handleInputChange}
                helperText={"Вкажіть серію"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть номер"}
                label={"Номер"}
                variant="outlined"
                fullWidth
                value={editUser.doctorOfScienceDiploma?.number}
                type={"string"}
                name={"doctorOfScienceDiploma.number"}
                onChange={handleInputChange}
                helperText={"Вкажіть номер"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть ким видано"}
                label={"Ким видано"}
                variant="outlined"
                fullWidth
                value={editUser.doctorOfScienceDiploma?.issuedBy}
                type={"string"}
                name={"doctorOfScienceDiploma.issuedBy"}
                onChange={handleInputChange}
                helperText={"Вкажіть ким видано"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <MobileDatePicker
                label={"Дата видачі"}
                inputFormat="MM/dd/yyyy"
                value={new Date(editUser.doctorOfScienceDiploma?.dateOfIssue)}
                onChange={(newDate) => {
                  const newState = {
                    ...editUser
                  };
                  newState.doctorOfScienceDiploma.dateOfIssue = newDate;
                  setEditUser(newState);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть тему дисертації"}
                label={"Тема дисертації"}
                variant="outlined"
                fullWidth
                value={editUser.doctorOfScienceDiploma?.dissertationTopic}
                type={"string"}
                name={"doctorOfScienceDiploma.dissertationTopic"}
                onChange={handleInputChange}
                helperText={"Вкажіть тему дисертації"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть найменування спеціальності"}
                label={"Найменування спеціальності"}
                variant="outlined"
                fullWidth
                value={editUser.doctorOfScienceDiploma?.speciality}
                type={"string"}
                name={"doctorOfScienceDiploma.speciality"}
                onChange={handleInputChange}
                helperText={"Вкажіть найменування спеціальності"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть шифр спеціальності"}
                label={"Шифр спеціальності"}
                variant="outlined"
                fullWidth
                value={editUser.doctorOfScienceDiploma?.codeAndName}
                type={"string"}
                name={"doctorOfScienceDiploma.codeAndName"}
                onChange={handleInputChange}
                helperText={"Вкажіть шифр спеціальності"}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component={"b"} variant={"b"}>{"Атестат доцента:"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть серію"}
                label={"Серія"}
                variant="outlined"
                fullWidth
                value={editUser.associateProfessorCertificate?.series}
                type={"string"}
                name={"associateProfessorCertificate.series"}
                onChange={handleInputChange}
                helperText={"Вкажіть серію"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть номер"}
                label={"Номер"}
                variant="outlined"
                fullWidth
                value={editUser.associateProfessorCertificate?.number}
                type={"string"}
                name={"associateProfessorCertificate.number"}
                onChange={handleInputChange}
                helperText={"Вкажіть номер"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть ким видано"}
                label={"Ким видано"}
                variant="outlined"
                fullWidth
                value={editUser.associateProfessorCertificate?.issuedBy}
                type={"string"}
                name={"associateProfessorCertificate.issuedBy"}
                onChange={handleInputChange}
                helperText={"Вкажіть ким видано"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <MobileDatePicker
                label={"Дата видачі"}
                inputFormat="MM/dd/yyyy"
                value={new Date(editUser.associateProfessorCertificate?.dateOfIssue)}
                onChange={(newDate) => {
                  const newState = {
                    ...editUser
                  };
                  newState.associateProfessorCertificate.dateOfIssue = newDate;
                  setEditUser(newState);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть спеціальність"}
                label={"Спеціальність"}
                variant="outlined"
                fullWidth
                value={editUser.associateProfessorCertificate?.departmentWasAssigned}
                type={"string"}
                name={"associateProfessorCertificate.departmentWasAssigned"}
                onChange={handleInputChange}
                helperText={"Вкажіть спеціальність"}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component={"b"} variant={"b"}>{"Атестат професора:"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть серію"}
                label={"Серія"}
                variant="outlined"
                fullWidth
                value={editUser.professorCertificate?.series}
                type={"string"}
                name={"professorCertificate.series"}
                onChange={handleInputChange}
                helperText={"Вкажіть серію"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть номер"}
                label={"Номер"}
                variant="outlined"
                fullWidth
                value={editUser.professorCertificate?.number}
                type={"string"}
                name={"professorCertificate.number"}
                onChange={handleInputChange}
                helperText={"Вкажіть номер"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть ким видано"}
                label={"Ким видано"}
                variant="outlined"
                fullWidth
                value={editUser.professorCertificate?.issuedBy}
                type={"string"}
                name={"professorCertificate.issuedBy"}
                onChange={handleInputChange}
                helperText={"Вкажіть ким видано"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <MobileDatePicker
                label={"Дата видачі"}
                inputFormat="MM/dd/yyyy"
                value={new Date(editUser.professorCertificate?.dateOfIssue)}
                onChange={(newDate) => {
                  const newState = {
                    ...editUser
                  };
                  newState.professorCertificate.dateOfIssue = newDate;
                  setEditUser(newState);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть спеціальність"}
                label={"Спеціальність"}
                variant="outlined"
                fullWidth
                value={editUser.professorCertificate?.departmentWasAssigned}
                type={"string"}
                name={"professorCertificate.departmentWasAssigned"}
                onChange={handleInputChange}
                helperText={"Вкажіть спеціальність"}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component={"b"} variant={"b"}>{"Атестат старшого наукового співробітника:"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть серію"}
                label={"Серія"}
                variant="outlined"
                fullWidth
                value={editUser.seniorScientistCertificate?.series}
                type={"string"}
                name={"seniorScientistCertificate.series"}
                onChange={handleInputChange}
                helperText={"Вкажіть серію"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть номер"}
                label={"Номер"}
                variant="outlined"
                fullWidth
                value={editUser.seniorScientistCertificate?.number}
                type={"string"}
                name={"seniorScientistCertificate.number"}
                onChange={handleInputChange}
                helperText={"Вкажіть номер"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть ким видано"}
                label={"Ким видано"}
                variant="outlined"
                fullWidth
                value={editUser.seniorScientistCertificate?.issuedBy}
                type={"string"}
                name={"seniorScientistCertificate.issuedBy"}
                onChange={handleInputChange}
                helperText={"Вкажіть ким видано"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <MobileDatePicker
                label={"Дата видачі"}
                inputFormat="MM/dd/yyyy"
                value={new Date(editUser.seniorScientistCertificate?.dateOfIssue)}
                onChange={(newDate) => {
                  const newState = {
                    ...editUser
                  };
                  newState.seniorScientistCertificate.dateOfIssue = newDate;
                  setEditUser(newState);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть спеціальність"}
                label={"Спеціальність"}
                variant="outlined"
                fullWidth
                value={editUser.seniorScientistCertificate?.departmentWasAssigned}
                type={"string"}
                name={"seniorScientistCertificate.departmentWasAssigned"}
                onChange={handleInputChange}
                helperText={"Вкажіть спеціальність"}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component={"b"} variant={"b"}>{"Сертифікат з англійської мови (на рівні не нижче В2):"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть серію"}
                label={"Серія"}
                variant="outlined"
                fullWidth
                value={editUser.certificateOfEnglish?.series}
                type={"string"}
                name={"certificateOfEnglish.series"}
                onChange={handleInputChange}
                helperText={"Вкажіть серію"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть номер"}
                label={"Номер"}
                variant="outlined"
                fullWidth
                value={editUser.certificateOfEnglish?.number}
                type={"string"}
                name={"certificateOfEnglish.number"}
                onChange={handleInputChange}
                helperText={"Вкажіть номер"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <MobileDatePicker
                label={"Дата видачі"}
                inputFormat="MM/dd/yyyy"
                value={new Date(editUser.certificateOfEnglish?.dateOfIssue)}
                onChange={(newDate) => {
                  const newState = {
                    ...editUser
                  };
                  newState.certificateOfEnglish.dateOfIssue = newDate;
                  setEditUser(newState);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ borderBottom: 1, borderColor: "divider", padding: "10px 0" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component={"b"} variant={"b"}>{"Відомості про підвищення кваліфікації:"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть yайменування закладу"}
                label={"Найменування закладу"}
                variant="outlined"
                fullWidth
                value={editUser.certificationTraining?.name}
                type={"string"}
                name={"certificationTraining.name"}
                onChange={handleInputChange}
                helperText={"Вкажіть yайменування закладу"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть вид документа"}
                label={"Вид документа"}
                variant="outlined"
                fullWidth
                value={editUser.certificationTraining?.documentType}
                type={"string"}
                name={"certificationTraining.documentType"}
                onChange={handleInputChange}
                helperText={"Вкажіть вид документа"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть тему"}
                label={"Тема"}
                variant="outlined"
                fullWidth
                value={editUser.certificationTraining?.topic}
                type={"string"}
                name={"certificationTraining.topic"}
                onChange={handleInputChange}
                helperText={"Вкажіть тему"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                placeholder={"Вкажіть кількість кредитів (годин)"}
                label={"Кількість кредитів (годин)"}
                variant="outlined"
                fullWidth
                value={editUser.certificationTraining?.numberOfStudyСredits}
                type={"string"}
                name={"certificationTraining.numberOfStudyСredits"}
                onChange={handleInputChange}
                helperText={"Вкажіть кількість кредитів (годин)"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <MobileDatePicker
                label={"Дата видачі"}
                inputFormat="MM/dd/yyyy"
                value={new Date(editUser.certificationTraining?.dateOfIssue)}
                onChange={(newDate) => {
                  const newState = {
                    ...editUser
                  };
                  newState.certificationTraining.dateOfIssue = newDate;
                  setEditUser(newState);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{display: 'flex', justifyContent: 'flex-end'}}>
            <Button onClick={updateUserInfo} variant={"contained"}>Оновити</Button>
          </Grid>
        </Grid>
      </Grid>
    </ErrorBoundary>
  );
}

export default UserEducationDocuments;
